import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.account': {
         accountPartiallyBlocked:
            'Twoje konto zostało częściowo zablokowane z powodu nieopłaconej w terminie faktury - opłać fakturę i skontaktuj się z działem sprzedaży.',
         accountPassword: 'Hasło do konta',
         additionalVerificationRequired: 'Wymagana dodatkowa weryfikacja',
         authenticationRequired: 'Przeloguj się w celu ponownego uwierzytelnienia.',
         authorize: 'Autoryzuj',
         certificateNoLongerValid:
            'Nieprawidłowy certyfikat osobisty. Zaktualizuj go w zakładce "Moje konto" i ponów próbę.',
         confirmActionByPassword: 'Potwierdź działanie hasłem, aby bezpiecznie użyć certyfikatu.',
         email: 'E-mail',
         incorrectPassword: 'Niepoprawne hasło',
         invalidPersonalCertificatePrivateKey:
            'Nieprawidłowy certyfikat osobisty. Wgraj go ponownie w zakładce "Moje konto".',
         mfaModal: {
            accountBlockedError: 'Konto jest zablokowane w systemie NFZ. Spróbuj ponownie za 15 minut.',
            invalidCodeError: 'Nieudane logowanie. Sprawdź ponownie kod z aplikacji lub dane logowania.',
            invalidCodeFormatError: 'Kod musi składać się z sześciu cyfr.',
            loginButton: 'Zaloguj się',
            passwordExpiredError: 'Hasło wygasło. Musisz dokonać zmiany hasła.',
            subtitle: 'Aby dalej korzystać <bold>z usług NFZ,</bold> musisz się ponownie zalogować.',
            title: 'Logowanie NFZ - weryfikacja dwuetapowa',
            totpFieldHint:
               'Wpisz sześciocyfrowy kod z aplikacji do weryfikacji dwuetapowej (np. Microsoft Authenticator lub Google Authenticator).',
            totpFieldLabel: 'Kod hasła jednorazowego',
            totpFieldPlaceholder: 'np. 123 123',
         },
         noValidPersonalCertificate: 'Brak ważnego certyfikatu. Wgraj go w zakładce "Moje konto".',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.account');
export const nfzMfaTranslationKeys = translationKeys.mfaModal;
